export function getScrollTop() {
	return window.pageYOffset || document.body.scrollTop;
}
export function getScrollLeft() {
	return window.pageXOffset || document.body.scrollLeft;
}
